import React, { useState } from "react";
import PropTypes from "prop-types";
import LtvFilter from "../../pages/reports/ltv-report/LtvFilter";
import privateAxios from "../../utils/axiosPrivate";
import { showToast, formatDateWithDayjs } from "../../utils/utils";
import {
  showToastType,
  VIEW_OPTIONS_TYPE,
  MONTH_12
} from "../../utils/constants/appConstants";
import {
  ltvReport,
  buttonName,
  checklist,
  fileDownloadMessages
} from "../../locales/en";
import Style from "./modal.module.scss";
import "./modalstyle.scss";
import { getSalesReferralCSVUrl } from "../../utils/constants/apiEndPoints";
import CommonModal from "./CommonModal";
import { PERIOD_BY_VIEWTYPE } from "../../utils/getDropdownOptions";
export default function LTVReportDownloadModal({ isOpen, toggle }) {
  const currentDate = new Date();

  const initialLoading = {
    downloadBtn: false
  };

  const initialLtvFilter = {
    viewType: VIEW_OPTIONS_TYPE?.MONTH,
    salesLeadName: "",
    period: MONTH_12,
    country: "",
    customerDuration: "",
    referralType: "",
    referralSubType: "",
    referralPartnerName: "",
    asAtDate: new Date().toISOString()
  };

  const [loading, setLoading] = useState(initialLoading);
  const [ltvFilter, setLtvFilter] = useState(initialLtvFilter);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLtvFilter((prev) => {
      if (name === "viewType") {
        return {
          ...prev,
          viewType: value,
          period: PERIOD_BY_VIEWTYPE[value] ?? ""
        };
      }
      return { ...prev, [name]: value };
    });
  };

  const downloadLtvReport = async () => {
    try {
      setLoading((prev) => ({ ...prev, downloadBtn: true }));

      const payload = { ...ltvFilter };

      const response = await privateAxios.post(
        getSalesReferralCSVUrl,
        payload,
        { responseType: "blob" }
      );

      const fileName = `Report_${ltvFilter.viewType}_${ltvFilter.period}_${formatDateWithDayjs(currentDate, "DD-MMM-YYYY")}.csv`;

      // Create blob and download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      showToast(checklist?.errors?.fileDownload, showToastType.success);
      toggle();
    } catch (err) {
      showToast(
        err?.response?.data?.message ||
          fileDownloadMessages?.errors?.fileDownloadFailed,
        showToastType.error
      );
    } finally {
      setLoading((prev) => ({ ...prev, downloadBtn: false }));
    }
  };
  const handleOnClose = () => {
    toggle();
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={ltvReport?.downloadModal?.title}
      modalClassName={`${Style.xeroModal} modal-xl ltvReportDomldMdl`}
      bodyClassName={`${Style.aiScModalContent} modal-content`}
      footerButtons={[
        {
          label: loading.downloadBtn ? buttonName.loading : buttonName.download,
          className: "btn btn-primary",
          onClick: downloadLtvReport
        },
        {
          label: buttonName?.close,
          className: "btn btn-blue",
          onClick: handleOnClose
        }
      ]}
    >
      <div className="row flex-wrap mt-4 mb-3 filter full_filter justify-content-between search report_download">
        <LtvFilter ltvFilter={ltvFilter} onInputChange={handleInputChange} />
      </div>
    </CommonModal>
  );
}

LTVReportDownloadModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};
